import type {
  CompareByVariantResult,
  PricingMatrixResult,
} from "@/modules/pricing/domain/types";
import { config } from "@/shared/lib/config";
import { fetcher } from "@/shared/lib/fetcher";

export type PricingMatrixQuery = {
  branchIds: string[];
  productId?: string | null;
  search?: string | null;
  limit?: number;
  offset?: number;
};

export async function getPricingMatrix(
  query: PricingMatrixQuery,
): Promise<PricingMatrixResult> {
  const url = new URL(`${config.apiUrl}/pricing/matrix`);
  url.searchParams.set("branchIds", query.branchIds.join(","));
  if (query.productId) url.searchParams.set("productId", query.productId);
  if (query.search) url.searchParams.set("search", query.search);
  if (query.limit != null) url.searchParams.set("limit", String(query.limit));
  if (query.offset != null) url.searchParams.set("offset", String(query.offset));
  return fetcher.get<PricingMatrixResult>(url.toString());
}

export type UpsertOverridePayload = {
  branchId: string;
  variantId: string;
  overridePriceLak: number;
};

export async function upsertOverride(
  payload: UpsertOverridePayload,
): Promise<{ id: string }> {
  return fetcher.put<{ id: string }>(
    `${config.apiUrl}/pricing/overrides`,
    payload,
  );
}

export async function deactivateOverride(
  branchId: string,
  variantId: string,
): Promise<{ ok: boolean }> {
  return fetcher.delete<{ ok: boolean }>(
    `${config.apiUrl}/pricing/overrides/${branchId}/${variantId}`,
  );
}

export async function getCompareByVariant(
  variantId: string,
): Promise<CompareByVariantResult> {
  const url = new URL(`${config.apiUrl}/pricing/compare-by-variant`);
  url.searchParams.set("variantId", variantId);
  return fetcher.get<CompareByVariantResult>(url.toString());
}
